/**
 * Name: Modal
 * Author: @Gaurav
 * Date: 27-07-2021
 */
import React from 'react';
import { Button, Modal } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import './style.scss';

const AlertModal = (props) => {
  const onClose = props?.onClose;
  const handelDelete = props?.handelDelete;
  const disabled = true;
  const alertStyle = props?.alertStyle;
  const description = props?.description;
  const heading = props?.heading;
  const icon = props?.icon;
  const body = (
    <div className={`modal_wrap ${alertStyle}`}>
      <DialogContent>
        {icon && <div className="alert-icon-container">{icon}</div>}
        {heading && (
          <DialogTitle id="alert-dialog-title" className="modal-heading">
            {heading}
          </DialogTitle>
        )}
        <DialogContentText id="alert-dialog-description">{description || 'Are you sure want to delete?'}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className={disabled ? 'dft_btn disable_color' : 'dft_btn'} onClick={onClose}>
          Cancel
        </Button>
        <Button className="dft_btn ok_btn" onClick={handelDelete}>
          Ok
        </Button>
      </DialogActions>
    </div>
  );
  return (
    <div>
      <Modal {...props} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
        {body}
      </Modal>
    </div>
  );
};
export default AlertModal;

